// SSOT — Lógica unificada de validação de cadastro do portal do cliente.
// Usada por PortalLayout (HardLockGate) e PortalCompletarCadastro (hydrateForm).
// Artigo 122 — Doutrina SSOT: nenhum componente deve reimplementar esta lógica.

export function isRegistrationComplete(c) {
  if (!c) return false;
  const type = String(c?.type || '').toLowerCase();
  const NON_HUMAN = ['animal', 'jurídica', 'juridica', 'pj', 'espolio', 'espólio', 'cnpj', 'massa'];
  if (NON_HUMAN.some((k) => type.includes(k))) return true;
  if (c?.onboardingStatus === 'PENDING_APPROVAL') return false;
  const name = String(c?.fullName || c?.qualification?.physical?.socialName || c?.qualification?.physical?.name || '').trim();
  if (!name) return false;
  const cpf = String(c?.qualification?.physical?.cpf || c?.cpf || '').replace(/\D/g, '');
  if (cpf.length < 11) return false;
  const email = String(c?.contact?.email || '').trim();
  if (!email) return false;
  const whatsapp = String(c?.contact?.phonePrimary || c?.contact?.phone || '').replace(/\D/g, '');
  if (whatsapp.length < 10) return false;
  const profession = String(c?.qualification?.physical?.profession || '').trim();
  if (!profession) return false;
  const zipCode = String(c?.location?.address?.zipCode || c?.location?.address?.cep || '').replace(/\D/g, '');
  if (zipCode.length < 8) return false;
  const street = String(c?.location?.address?.street || '').trim();
  if (!street) return false;
  const city = String(c?.location?.address?.city || '').trim();
  if (!city) return false;
  const uf = String(c?.location?.address?.state || c?.location?.address?.uf || '').trim();
  if (!uf) return false;
  return true;
}

export default isRegistrationComplete;
